import {
  POINT_TRANSFER_CODE_PARAM,
  extractPointTransferCodeFromScanPayload,
} from "./pointsTransfer"
import { extractProfilePass, hasProfilePassParam, PROFILE_PASS_PARAM } from "../profilePass/payload"

const URL_LIKE_PATTERN = /^(?:[a-z][a-z\d+\-.]*:|\/|\?|www\.)/i

const getUrlParsingBase = () =>
  typeof window !== "undefined" ? window.location.origin : "https://winfacil.local"

const getCodeFromUrlPayload = (payload: string) => {
  if (!URL_LIKE_PATTERN.test(payload)) {
    return null
  }

  try {
    const normalizedPayload = payload.startsWith("www.") ? `https://${payload}` : payload
    const parsedUrl = new URL(normalizedPayload, getUrlParsingBase())
    const code = parsedUrl.searchParams.get("code")?.trim()

    return code || null
  } catch {
    return null
  }
}

export const extractCodeFromScanPayload = (payload: string) => {
  const trimmedPayload = payload.trim()

  if (!trimmedPayload) {
    return ""
  }

  return getCodeFromUrlPayload(trimmedPayload) ?? trimmedPayload
}

export type ScanPayloadRoute =
  | { type: "profilePass"; code: string }
  | { type: "pointTransfer"; code: string }
  | { type: "ticket"; code: string }
  | { type: "empty"; code: "" }

export const getScanPayloadRoute = (payload: string): ScanPayloadRoute => {
  const profilePass = extractProfilePass(payload)
  if (profilePass) return { type: "profilePass", code: profilePass }
  if (hasProfilePassParam(payload)) return { type: "empty", code: "" }
  const pointTransferCode = extractPointTransferCodeFromScanPayload(payload)
  if (pointTransferCode) {
    return {
      type: "pointTransfer",
      code: pointTransferCode,
    }
  }

  const code = extractCodeFromScanPayload(payload)
  if (!code) {
    return {
      type: "empty",
      code: "",
    }
  }

  return {
    type: "ticket",
    code,
  }
}

export const applyScanRouteToSearchParams = (
  route: ScanPayloadRoute,
  searchParams: URLSearchParams,
) => {
  const nextParams = new URLSearchParams(searchParams)
  if (route.type !== "empty") {
    nextParams.delete(PROFILE_PASS_PARAM)
    nextParams.delete(POINT_TRANSFER_CODE_PARAM)
    nextParams.delete("code")
  }

  if (route.type === "profilePass") {
    nextParams.set(PROFILE_PASS_PARAM, route.code)
  } else if (route.type === "pointTransfer") {
    nextParams.set(POINT_TRANSFER_CODE_PARAM, route.code)
  } else if (route.type === "ticket") {
    nextParams.set("code", route.code)
  }

  return nextParams
}
